import {Anchor, createTopAnchor} from '@cypro/ui/components/ui/infinite-data-table'
import {queries} from '@/shared/integrations/zero'
import {ListUnitsInput} from '@cypro/engine/queries'
import {Unit} from '@cypro/engine/schema'
import {useQuery} from '@rocicorp/zero/react'
import {useState} from 'react'

const LIMIT = 200

export function useGetUnits({filters}: Omit<Partial<ListUnitsInput>, 'cursor'> = {}) {
  const [anchor, setAnchor] = useState<Anchor<Unit>>(createTopAnchor<Unit>())
  const query = queries.products.listUnits({filters})
  const [units, meta] = useQuery(query)

  return {
    query,
    meta,
    units,
    anchor,
    fetchMore: setAnchor,
    canFetchMore: units.length === LIMIT,
    isFetching: meta.type === 'unknown',
  }
}
